// Case Studies
import Equitrack from "../components/pages/caseStudies/Items/Equitrack";
import NamakaComplianceAthena from "../components/pages/caseStudies/Items/NamakaComplianceAthena";
import NamakaSubseaNAMS from "../components/pages/caseStudies/Items/NamakaSubseaNAMS";
import StockTrack from "../components/pages/caseStudies/Items/StockTrack";
import TemsEagle from "../components/pages/caseStudies/Items/TemsEagle";
import TemsTiger from "../components/pages/caseStudies/Items/TemsTiger";
import Timeherent from "../components/pages/caseStudies/Items/Timeherent";
import Condi from "../components/pages/caseStudies/Items/Condi";

export default function CaseStudies() {
    return (
        <main className="below-navbar d4-container case-studies-section" style={{ marginLeft: "auto", marginRight: "auto" }}>
            <h1 className="pb-3">Our case studies</h1>

            <div className="case-studies-container">
                <TemsEagle />
                <TemsTiger />
                <NamakaSubseaNAMS />
                <NamakaComplianceAthena />
                <Equitrack />
                <StockTrack />
                <Timeherent />
                <Condi />
            </div>
        </main>
    )
}